import { render } from "./topic-card.vue?vue&type=template&id=43f3919c&ts=true"
import script from "./topic-card.vue?vue&type=script&lang=ts"
export * from "./topic-card.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__